var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1876 7.875H24.7709V5.45834C24.7713 5.22022 24.7246 4.98439 24.6336 4.76435C24.5426 4.5443 24.4091 4.34436 24.2408 4.17599C24.0724 4.00763 23.8725 3.87413 23.6524 3.78316C23.4324 3.69218 23.1965 3.64552 22.9584 3.64584H13.7449C13.4751 3.64589 13.2088 3.58571 12.9652 3.46969C12.7217 3.35367 12.5071 3.18473 12.3372 2.97521L11.153 1.51917C10.9273 1.23987 10.6419 1.01461 10.3179 0.859889C9.9938 0.70517 9.63921 0.624915 9.2801 0.625002H2.41677C2.17866 0.624683 1.94283 0.671348 1.72278 0.762322C1.50273 0.853296 1.3028 0.986792 1.13443 1.15516C0.96606 1.32353 0.832564 1.52347 0.74159 1.74351C0.650616 1.96356 0.603951 2.19939 0.604269 2.4375V20.3027C0.60302 20.5748 0.656382 20.8445 0.761196 21.0956C0.86601 21.3467 1.02015 21.5743 1.21448 21.7648C1.40498 21.9591 1.63254 22.1133 1.88368 22.2181C2.13482 22.3229 2.40443 22.3763 2.67656 22.375H23.0128C23.4617 22.3749 23.8985 22.2294 24.2579 21.9604C24.6172 21.6914 24.8799 21.3134 25.0066 20.8827L28.3476 9.42167C28.3997 9.2416 28.4093 9.05188 28.3756 8.86748C28.3419 8.68308 28.2658 8.50903 28.1533 8.35906C28.0408 8.20909 27.895 8.0873 27.7275 8.0033C27.5599 7.9193 27.3751 7.87538 27.1876 7.875Z",
    fill: "none",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1869 7.875H10.0127C9.56434 7.87505 9.12807 8.02054 8.7694 8.28961C8.41072 8.55868 8.149 8.93683 8.0235 9.36729L4.66434 20.8836C4.53884 21.3138 4.27718 21.6918 3.91863 21.9607C3.56008 22.2296 3.12398 22.375 2.67578 22.375H23.0143C23.4628 22.3751 23.8992 22.2296 24.2579 21.9605C24.6167 21.6915 24.8785 21.3132 25.004 20.8827L28.3469 9.42167C28.3995 9.24158 28.4093 9.05173 28.3758 8.86717C28.3422 8.6826 28.2662 8.50838 28.1536 8.35831C28.041 8.20824 27.8951 8.08644 27.7273 8.00255C27.5595 7.91866 27.3745 7.87499 27.1869 7.875Z",
    fill: "none",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolder);
export default __webpack_public_path__ + "static/media/Open Folder.6c876df154341791448395955e4b74d7.svg";
export { ForwardRef as ReactComponent };